import { ref } from 'vue';
import { MaybeNull } from '../../../types';

const mobileActionsTarget$ = ref<MaybeNull<HTMLDivElement>>(null);
const desktopActionsTarget$ = ref<MaybeNull<HTMLDivElement>>(null);

export const useScreenActions = () => {
  return {
    mobileActionsTarget$,
    desktopActionsTarget$,
  };
};
